import { ReactNode, ButtonHTMLAttributes } from 'react';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  icon?: ReactNode;
  fullWidth?: boolean;
}

export function Button({
  variant = 'primary',
  size = 'md',
  icon,
  fullWidth,
  children,
  className = '',
  ...rest
}: Props) {
  const base =
    variant === 'primary'
      ? 'btn-primary'
      : variant === 'secondary'
      ? 'btn-secondary'
      : 'btn-ghost';

  const sz =
    size === 'sm'
      ? 'px-4 py-2 text-sm'
      : size === 'lg'
      ? 'px-6 py-4 text-base'
      : 'px-5 py-3 text-sm';

  return (
    <button
      {...rest}
      className={`${base} ${sz} ${fullWidth ? 'w-full' : ''} inline-flex items-center justify-center gap-2 ${className}`}
    >
      {icon}
      {children}
    </button>
  );
}
